module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAT9JREFUOE+dlNFVg0AQReftFmAJMR3ECiQVGDvQT+FD7QArMD/gZ+xAOkjogBKSDrSA3efCgUg4LCB7Dj/szD1v3s4MZOTYVBVCoYrszVAohi6Z6AdCdmUMKI+IzKcvfhBkE3UUYFElk8WQKi+IHxKQet9WAJg1nuTQp8oLsqkuE247SQcVmvUgiImsnKkL0WpFInDB5dd3MoCFGFsI5IRIispDm+jM/bgbe72R+8yBWobOpZEnlCURyvmBq3kc/oA2qMyeD6shzqfzq/0f9gepzG6Xw1Q2FP01pUSIuUcoWRN7CeppQu9IdJqzo0i9UPA+TRFfEdptryKTqC2A5ykgkm86snEvyDMWeR3cHZfcjcu5+y9Kc7vnu9VPuRvSuBnSeohLBTWQRxXapV8ReQ1B7Ns91Y4SOiDcWjGbBvQL+P+NkupsnuoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xing1.png
// module id = h1IR
// module chunks = 2